/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Not_SeatedInputs */



/**
* | output |
* | --- |
* | "Not seated" |
*
* @param {League_Final_Not_SeatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_not_seated = /** @type {((inputs?: League_Final_Not_SeatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Not_SeatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non placé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin sentar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fora da mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non in finale")
	return /** @type {LocalizedString} */ ("Not seated")
});